import { gql } from '@apollo/client';

export interface InviteClinicianInput {
  email: string;
  clinicId?: string;
  nameFirst?: string;
  nameLast?: string;
}

export const INVITE_CLINICIAN = gql`
  mutation inviteClinician($input: InviteClinicianInput!) {
    inviteClinician(input: $input) {
      id
    }
  }
`;
